export const iconFontAwesomeCommunicationMessage = (
	<i className="fa-solid fa-message"></i>
);
